module.exports = __webpack_public_path__ + "static/img/img_cabinet.cdc3874f.png";